import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-receipt-confirmation-form',
  templateUrl: './receipt-confirmation-form.component.html',
  styleUrls: ['./receipt-confirmation-form.component.css']
})
export class ReceiptConfirmationFormComponent implements OnInit {
  title="Receipt Confirmation";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/receipt-confirmation/receipt-confirmation-form/receipt-confirmation-form.component.ts